/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutDigitalCareController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {

            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'DigitalCare';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.DigitalCareCompleted = false;
            $scope.Control.IsOTPActive = false;
            $scope.Control.VATSubmitted = false;
            $scope.Control.ResendCodeEnabled = false;
            $scope.Control.VoucherSubmitted = false;

            $scope.Control.TaxIdentifierRequired = false;
            $scope.Control.TaxIdentifierInvalid = false;
            $scope.Control.OTPRequired = false;
            $scope.Control.OTPInvalid = false;
            $scope.Control.VoucherCodeRequired = false;
            $scope.Control.VoucherCodeInvalid = false;
            $scope.Control.VoucherCodeOpt1Invalid = false;
            $scope.Control.VoucherCodeOpt2Invalid = false;
            $scope.Control.VoucherCodeInvalidOrder = false;
            $scope.Control.SubmitVoucherError = false;

            $scope.Control.VAT = '';
            $scope.Control.OTPInput1 = '';
            $scope.Control.OTPInput2 = '';
            $scope.Control.OTPInput3 = '';
            $scope.Control.OTPInput4 = '';
            $scope.Control.OTPInput5 = '';
            $scope.Control.OTPInput6 = '';
            $scope.Control.OTPInput = ''; 
            $scope.Control.VoucherCode = '';
            $scope.Control.VoucherCodeOpt1 = '';
            $scope.Control.VoucherCodeOpt2 = '';

            $scope.Control.ResultMessage = '';

            $scope.Control.sendOTP = function () {

                if (!$scope.Control.TaxIdentifier || $scope.Control.TaxIdentifier.trim() == '') {
                    $scope.Control.TaxIdentifierRequired = true;
                    return;
                }

                $scope.Control.TaxIdentifierRequired = false;
                $scope.Control.Loading = true;

                ControlService.invokeCheckout($scope, $element, 'SetDigitalCareOTP', $scope.Control.TaxIdentifier).then(function (response) {
                    var response = jQuery.parseJSON(response);

                    $scope.Control.IsValid = response.result;                   
                    $scope.Control.OTP = response.OTP;
                    $scope.Control.OTPExpiration = response.OTPExpirationN;

                    if ($scope.Control.IsValid) {
                        $scope.Control.VATSubmitted = true;
                        $scope.Control.IsOTPActive = true;
                        $scope.Control.TaxIdentifierInvalid = false;
                        $scope.Control.ResendCodeEnabled = false;

                        $scope.Control.initCountdown();
                    } else {
                        $scope.Control.VATSubmitted = false;
                        $scope.Control.IsOTPActive = false;
                        $scope.Control.TaxIdentifierInvalid = true;
                    }

                    //$scope.setControlValue(controlName, $scope.Control.IsOTPActive);
                    //$scope.setControlValue(controlName, $scope.Control.TaxIdentifierError);

                    $scope.Control.Loading = false;

                }, function (ex) {
                    console.log(ex);
                    $scope.Control.IsValid = false;
                    $scope.Control.VATSubmitted = false;
                    $scope.Control.Loading = false;
                    
                    $scope.Control.Result = 'DigitalCare_ServiceError';
                    $scope.Control.ResultMessage = 'Generic error. Please try again later.';

                    $scope.$apply();

                });
            };

            $scope.Control.initCountdown = function () {
                // Get current date plus 1 minute
                var countDownDate = $scope.Control.OTPExpiration;

                //one minute countdown for testing
                //var countDownDate = new Date(Date.now() + (1 * 60 * 1000)).getTime();

                // Update the count down every 1 second
                var x = setInterval(function () {

                    // Get today's date and time
                    var now = new Date().getTime();

                    // Find the distance between now and the count down date
                    var distance = countDownDate - now;

                    // Time calculations for days, hours, minutes and seconds
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    // Output the result
                    document.getElementById("dcCountdown").innerHTML = minutes + "m " + seconds + "s ";

                    // If the count down is over
                    if (distance < 0) {
                        clearInterval(x);
                        document.getElementById("dcCountdown").innerHTML = "CODE EXPIRED";
                        document.getElementById("dcCountdown").classList.add("expired");

                        $scope.Control.ResendCodeEnabled = true;
                        $scope.$apply();
                    }

                }, 1000);
            };

            $scope.Control.resendCode = function () {
                $scope.Control.resetVoucher();
                $scope.Control.sendOTP();
            };

            $scope.Control.submitVoucher = function () {
                $scope.Control.Loading = true;
                $scope.Control.SubmitVoucherError = false;

                $scope.Control.OTPInput = $scope.Control.OTPInput1 + $scope.Control.OTPInput2 + $scope.Control.OTPInput3 + $scope.Control.OTPInput4 + $scope.Control.OTPInput5 + $scope.Control.OTPInput6;

                if (!$scope.Control.OTPInput || $scope.Control.OTPInput.trim() == '') {
                    $scope.Control.SubmitVoucherError = true;
                    $scope.Control.OTPRequired = true;
                } else {
                    $scope.Control.OTPRequired = false;
                }

                if (!$scope.Control.VoucherCode || $scope.Control.VoucherCode.trim() == '') {
                    $scope.Control.SubmitVoucherError = true;
                    $scope.Control.VoucherCodeRequired = true;
                } else {
                    $scope.Control.VoucherCodeRequired = false;
                }

                if ($scope.Control.VoucherCodeOpt1.trim() == '' && $scope.Control.VoucherCodeOpt2.trim() != '') {
                    $scope.Control.SubmitVoucherError = true;
                    $scope.Control.VoucherCodeInvalidOrder = true;
                } else {
                    $scope.Control.VoucherCodeInvalidOrder = false;
                }

                if ($scope.Control.SubmitVoucherError) return;

                var vouchersArr = [], data;

                if ($scope.Control.VoucherCode) vouchersArr.push($scope.Control.VoucherCode);
                if ($scope.Control.VoucherCodeOpt1) vouchersArr.push($scope.Control.VoucherCodeOpt1);
                if ($scope.Control.VoucherCodeOpt2) vouchersArr.push($scope.Control.VoucherCodeOpt2);

                data = { Otp: $scope.Control.OTPInput, Coupons: vouchersArr }

                ControlService.invokeCheckout($scope, $element, 'DigitalCareValidateOTPCoupons', data).then(function (response) {
                    var response = jQuery.parseJSON(response.data);

                    $scope.Control.IsValid = response.Data.Result.result;
                    $scope.Control.VoucherSubmitted = true;

                    if ($scope.Control.IsValid) {
                        $scope.Control.ResultMessage = response.Data.Result.VouchersSubmittedText;
                        $scope.Control.DigitalCareCompleted = true;

                        $scope.Order.Wrapper.reload().then(function () {
                            $scope.Control.Loading = false;
                        }, function (error) {
                            $scope.Control.Loading = false;
                            throw error;
                        });

                    } else {
                        $scope.Control.DigitalCareCompleted = false;

                        if (!response.Data.Result.IsValidOTP) {
                            $scope.Control.OTPInvalid = true;
                            $scope.Control.ResultMessage = response.Data.Result.NotValidOTPText;
                        }

                        if (!response.Data.Result.IsValidCoupons) {
                            var vouchers = response.Data.Result.Vouchers;
                            for (i = 0; i < vouchers.length; ++i) {
                                if (!vouchers[i].IsValid) {
                                    if (i == 0) {
                                        $scope.Control.VoucherCodeInvalid = true;
                                    } else {
                                        $scope.Control['VoucherCodeOpt' + i + 'Invalid'] = true;
                                    }
                                }
                            }

                            if ($scope.Control.ResultMessage != '') {
                                $scope.Control.ResultMessage = $scope.Control.ResultMessage + ' ' + response.Data.Result.NotValidCouponsText;
                            } else {
                                $scope.Control.ResultMessage = response.Data.Result.NotValidCouponsText;
                            }
                        }
                        
                    }

                    $scope.Control.Loading = false;

                }, function (ex) {
                    console.log(ex);
                    $scope.Control.IsValid = false;
                    $scope.Control.VoucherSubmitted = true;
                    $scope.Control.DigitalCareCompleted = false;
                    $scope.Control.Loading = false;

                    $scope.Control.Result = 'DigitalCare_ServiceError';
                    $scope.Control.ResultMessage = 'Generic error. Please try again later.';

                    $scope.$apply();
                });
            };

            $scope.Control.resetVoucher = function () {
                $scope.Control.DigitalCareCompleted = false;
                $scope.Control.ResendCodeEnabled = false;
                $scope.Control.VoucherSubmitted = false;

                $scope.Control.OTPRequired = false;
                $scope.Control.OTPInvalid = false;
                $scope.Control.VoucherCodeRequired = false;
                $scope.Control.VoucherCodeInvalid = false;
                $scope.Control.VoucherCodeOpt1Invalid = false;
                $scope.Control.VoucherCodeOpt2Invalid = false;
                $scope.Control.VoucherCodeInvalidOrder = false;

                $scope.Control.OTPInput1 = '';
                $scope.Control.OTPInput2 = '';
                $scope.Control.OTPInput3 = '';
                $scope.Control.OTPInput4 = '';
                $scope.Control.OTPInput5 = '';
                $scope.Control.OTPInput6 = '';
                $scope.Control.OTPInput = '';
                $scope.Control.VoucherCode = '';
                $scope.Control.VoucherCodeOpt1 = '';
                $scope.Control.VoucherCodeOpt2 = '';

                document.getElementById("dcCountdown").innerHTML = '';
                document.getElementById("dcCountdown").classList.remove("expired");
            };

            ControlService.getCheckoutData("GetDigitalCareData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);

                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

            angular.element($element.get(0)).ready(function () {
                //paste otp in every input
                $('input[type="text"][ng-model="Control.OTPInput1"]', $element).on('paste', function (e) {
                    var $this = $(this), pasteVal, pasteIntVal, digits = [];

                    setTimeout(function () {

                        pasteVal = $this.val();
                        pasteIntVal = parseInt(pasteVal);

                        if (pasteVal.length != 6 || isNaN(pasteIntVal)) return;

                        digits = pasteVal.split('');

                        for (i = 0; i < digits.length; ++i) {
                            $scope.Control['OTPInput' + (i + 1)] = digits[i];

                            if (i == (digits.length - 1)) {
                                $('input[type="text"][ng-model="Control.OTPInput' + (i + 1) + '"]', $element).focus();
                            }
                        }

                        $scope.$apply();

                    }, 100);
                });

                //allow only numbers
                $('input[type="text"][name="OTPInput"]', $element).on('keydown', function (e) {
                    //detect ctrl + v
                    var ctrl = e.ctrlKey ? e.ctrlKey : ((e.keyCode === 17) ? true : false);
                    if (e.keyCode == 86 && ctrl) {
                        $('input[type="text"][ng-model="Control.OTPInput1"]', $element).trigger('paste')
                        return;
                    }

                    numbersOnly(e);
                });

                $('input[type="text"][name="OTPInput"]', $element).on('keyup', function (e) {
                    //backspace - focus previous input
                    if (e.keyCode == 8) {
                        $(this).parent().prev().find('input').focus();
                        return;
                    }
                    //focus next input
                    if ($(this).val() != "") {
                        $(this).parent().next().find('input').focus();
                        return;
                    }
                });

               //focus in voucher if voucherOpt1 is not filled
                $('input[type="text"][name="voucherOpt1"]', $element).on('focus', function (e) {
                    if ($scope.Control.VoucherCode == '') {
                        $('input[type="text"][name="voucher"]', $element).focus();
                        return;
                    }
                });

                //focus in voucherOpt1 if voucherOpt2 is not filled
                $('input[type="text"][name="voucherOpt2"]', $element).on('focus', function (e) {
                    if ($scope.Control.VoucherCodeOpt1 == '') {
                        $('input[type="text"][name="voucherOpt1"]', $element).focus();
                        return;
                    }
                });

            });

        });
})();